import { useEffect, type ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function Modal({
  title, subtitle, onClose, children, width = 520,
}: {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
}) {
  useEffect(() => {
    const h = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", h);
    return () => { document.body.style.overflow = ""; window.removeEventListener("keydown", h); };
  }, [onClose]);

  return (
    <div role="dialog" aria-modal="true" aria-label={title}
      className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel card" style={{ maxWidth: width }} onClick={(e) => e.stopPropagation()}>
        <header className="modal-head">
          <div>
            <h3 style={{ margin: 0, fontFamily: "var(--font-display)", fontSize: 18, fontWeight: 700 }}>{title}</h3>
            {subtitle && <p className="muted" style={{ fontSize: 12, margin: "2px 0 0" }}>{subtitle}</p>}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={onClose} aria-label="닫기">
            <FontAwesomeIcon icon={faXmark} style={{ width: 14, height: 14 }} />
          </button>
        </header>
        <div className="modal-body">{children}</div>
      </div>
      <style>{`
        .modal-backdrop {
          position: fixed; inset: 0; z-index: 100;
          background: color-mix(in oklch, oklch(10% 0 0) 55%, transparent);
          backdrop-filter: blur(4px);
          display: grid; place-items: center;
          padding: var(--s-5);
          animation: modal-fade 160ms var(--ease-out);
        }
        .modal-panel {
          width: 100%; max-height: 90vh; overflow: auto;
          animation: modal-rise 200ms var(--ease-out);
          box-shadow: var(--shadow-lg);
        }
        .modal-head {
          position: sticky; top: 0;
          background: var(--surface); z-index: 2;
          display: flex; justify-content: space-between; align-items: center;
          padding: var(--s-5); border-bottom: 1px solid var(--border);
        }
        .modal-body { padding: var(--s-5); }
        @keyframes modal-fade { from { opacity: 0 } to { opacity: 1 } }
        @keyframes modal-rise { from { opacity: 0; transform: translateY(12px) scale(0.98) } to { opacity: 1; transform: translateY(0) scale(1) } }
      `}</style>
    </div>
  );
}
